<template>
  <!-- 优惠劵列表 -->
  <div class="flex-qp discount">
    <div v-if="dataInfo.couponList&&dataInfo.couponList.length>0">
      <div class="header" @click="selectCoupons(-1,-1,1)">
        <div class="f28 color-333 f500">不使用优惠券</div>
        <div class="icon">
          <img v-if="indexId==-1" src="@/assets/images/vip/pic_thumb.jpg" alt />
          <img v-else src="@/assets/images/vip/pic.jpg" alt />
        </div>
      </div>
      <div class="content" v-for="(item,index) in dataInfo.couponList" :key="item.id">
        <div class="type flex-dc" v-if="item.couponType==2">
          <span>¥{{item.discountMoney}}</span>
          <span class="f28 color-f5">满{{item.fullMoney}}可用</span>
        </div>
        <div class="type" v-else>
          <div>{{item.shareDescription}}</div>
        </div>
        <div class="info">
          <div class="f30 color-222 f500 single-ellipsis">{{item.name}}</div>
          <!-- 优惠券类型：0:训练营抵扣券 1:私教坊抵扣券 2:满减券 -->
          <div class="f24 color-888 mt10 f500 single-ellipsis">仅限{{item.discountContent}}使用</div>
          <div
            class="f24 color-A mt30 single-ellipsis"
          >有效期至：{{dates.formatDate(new Date(item.endTime), 'yyyy-MM-dd')}}</div>
        </div>
        <div class="icon" @click="selectCoupons(item,index,1)">
          <img v-if="item.id==indexId && item.select" src="@/assets/images/vip/pic_thumb.jpg" alt />
          <img v-else src="@/assets/images/vip/pic.jpg" alt />
        </div>
      </div>
    </div>
    <gxxt-no-data class="mt200" v-else text="暂无可用优惠券～"></gxxt-no-data>
  </div>
</template>

<script>
import dates from '@/utils/dates'
import { GxxtNoData } from '@/components'
export default {
  components: { GxxtNoData },
  data() {
    return {
      id: 0,
      priceNum: 1,
      courseType: '',
      dataInfo: {},
      indexId: -1,
      priceData: 0,
      dates,
      time: null,
      disable: false,
    }
  },
  created() {
    this.id = this.$route.query.id
    this.priceNum = this.$route.query.priceNum
    this.courseType = this.$route.query.courseType
    this.priceData = this.$route.query.priceData
    this.usageCouponList()
  },
  methods: {
    async usageCouponList() {
      let data = {
        goodsId: this.id,
        goodsNum: this.priceNum,
      }
      let res = await this.api.vip.usageCouponList(data)
      if (res && res.code == 200) {
        this.dataInfo = res.data
        //测试数据
        // this.dataInfo = {
        // 	id: 177,
        // 	name: "私教坊课程全额抵扣券",
        // 	usageType: 2,
        // }
        // this.dataInfo.couponList = [{
        // 			couponType: 1,
        // 			discountContent: "仅限私教坊课程使用",
        // 			discountMoney: 0,
        // 			endTime: 1672502399000,
        // 			fullMoney: 0,
        // 			goodsType: 0,
        // 			id: 177,
        // 			name: "私教坊课程全额抵扣券",
        // 			shareDescription: "全额抵扣券",
        // 			startTime: 1641881443000,
        // 			status: 0,
        // 			userId: 4236,
        // 		},
        // 		{
        // 			couponType: 2,
        // 			discountContent: "满减劵",
        // 			discountMoney: 200,
        // 			endTime: 1672502399000,
        // 			fullMoney: 1000,
        // 			goodsType: 0,
        // 			id: 177,
        // 			name: "满减劵",
        // 			shareDescription: " ¥200满1000可用",
        // 			startTime: 1641881443000,
        // 			status: 0,
        // 			userId: 4236,
        // 		}
        // 	],
        this.setCouponsStore()
      }
    },

    setCouponsStore() {
      if (this.$store.getters['publicData/couponsInfo'] == -1) return
      if (this.dataInfo.couponList && this.dataInfo.couponList.length > 0) {
        //['publicData/couponsInfo'] 存在用户选择优先使用
        if (this.$store.getters['publicData/couponsInfo'].id >= 0) {
          this.dataInfo.couponList.map((item, index) => {
            if (item.id == this.$store.getters['publicData/couponsInfo'].id) {
              item.usageType = this.dataInfo.usageType
              this.selectCoupons(item, index)
            }
          })
        } else {
          //首次进入选择推荐优惠劵
          this.dataInfo.couponList.map((item, index) => {
            if (item.id == this.dataInfo.id) {
              item.usageType = this.dataInfo.usageType
              this.selectCoupons(item, index)
            }
          })
        }
      }
    },
    selectCoupons(item, index, type) {
      if (this.disable) return
      if (item == -1) {
        this.indexId = -1
        this.$store.commit('publicData/setCoupons', this.indexId)
      } else {
        this.indexId = item.id
        this.dataInfo.couponList[index].select = true
        item.isSelect = true
        //0:训练营，1是私教坊，全额抵扣券要给金额赋值。
        if (item.couponType == 0 || item.couponType == 1) {
          item.discountMoney = this.priceData
          item.usageType = this.dataInfo.usageType
        }
        item.priceNum = this.priceNum
        this.$store.commit('publicData/setCoupons', item)
      }
      //type==1,用户手动点击返回上一页
      if (type == 1) {
        this.disable = true
        this.$toaster({
          message: '优惠劵选择成功',
          duration: 3000,
          show: true,
        })
        this.time = setTimeout(() => {
          this.$router.go(-1)
        }, 1000)
      }
      this.$forceUpdate()
    },
  },
  destroyed() {
    clearTimeout(this.time)
  },
}
</script>

<style lang="less" scoped>
.discount {
  background: #f7f7f7;
  padding: 30px 32px;

  .header {
    width: 686px;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
  }

  .icon {
    img {
      width: 35px;
      height: 35px;
    }
  }

  .content {
    width: 686px;
    height: 220px;
    // background: #FFFFFF;
    margin-top: 30px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: row;
    align-items: center;
    background: url(../../assets/images/vip/bg-discount.jpg) no-repeat;
    background-size: 100% auto;

    .type {
      width: 224px;
      color: #ff5500;
      font-size: 40px;
      display: flex;
      justify-content: center;

      div {
        width: 120px;
        font-weight: 600;
      }
    }

    .info {
      width: 400px;
      text-align: left;
      padding-left: 26px;
    }
  }
}
</style>
